import { Box, Button, FormField, Input, Textarea } from '@amzn/awsui-components-core';
import React, { useState } from 'react';
import { EditCollectionHeaderProps } from './EditCollection';
import constants from '../../common/constants';
import { EDIT_COLLECTION_CHAR_LIMIT } from '../../api/UtilsApi';

function EditCollectionHeader({ collection, setCollection }: EditCollectionHeaderProps) {
  const [editingTitle, setEditingTitle] = useState<boolean>(false);
  const [editingDescr, setEditingDescr] = useState<boolean>(false);

  const handleEditTitle = () => {
    setEditingTitle(!editingTitle);
  };

  const updateTitle = (newTitle: string) => {
    const collectionCopy = Object.assign({}, collection);
    collectionCopy.title = newTitle;
    setCollection(collectionCopy);
  };

  const handleEditDescr = () => {
    setEditingDescr(!editingDescr);
  };

  const updateDescr = (newDescr: string) => {
    const collectionCopy = Object.assign({}, collection);
    collectionCopy.description = newDescr;
    setCollection(collectionCopy);
  };

  const renderTitle = () => {
    const charRemaining = EDIT_COLLECTION_CHAR_LIMIT - (collection?.title?.length ?? 0);
    const epicTitleLimit = charRemaining + ' characters remaining';
    return (
      <div className="edit-collection-headers">
        {editingTitle ? (
          <FormField
            errorText={
              // @ts-expect-error TS18048 - strict migration
              collection?.title.length > EDIT_COLLECTION_CHAR_LIMIT &&
              constants.COLLECTION_INPUT_CHARACTER_LIMIT_ERROR
            }
            constraintText={
              // @ts-expect-error TS18048 - strict migration
              collection?.title.length > EDIT_COLLECTION_CHAR_LIMIT ? (
                <></>
              ) : (
                <Box color="text-body-secondary">{epicTitleLimit}</Box>
              )
            }
            i18nStrings={{ errorIconAriaLabel: 'Error' }}
          >
            <Textarea
              value={collection?.title ?? ''}
              onChange={(event) => updateTitle(event.detail.value)}
              autoFocus
              rows={1}
              ariaRequired
            />
          </FormField>
        ) : (
          <Box variant="h2">{collection?.title ?? ''}</Box>
        )}
        {editingTitle ? (
          <Button
            variant="link"
            onClick={handleEditTitle}
            // @ts-expect-error TS18048 - strict migration
            disabled={collection?.title.length > EDIT_COLLECTION_CHAR_LIMIT}
          >
            {constants.DONE_EDIT_HEADER}
          </Button>
        ) : (
          <Button
            ariaLabel="Edit title"
            iconAlt="Edit title"
            iconName="edit"
            variant="inline-icon"
            onClick={handleEditTitle}
          />
        )}
      </div>
    );
  };

  const renderDescription = () => {
    const charRemaining = EDIT_COLLECTION_CHAR_LIMIT - (collection?.description?.length ?? 0);
    const epicDescrLimit = charRemaining + ' characters remaining';
    return (
      <div className="edit-collection-headers">
        {editingDescr ? (
          <FormField
            errorText={
              // @ts-expect-error TS18048 - strict migration
              collection?.description.length > EDIT_COLLECTION_CHAR_LIMIT &&
              constants.COLLECTION_INPUT_CHARACTER_LIMIT_ERROR
            }
            constraintText={
              // @ts-expect-error TS18048 - strict migration
              collection?.description.length > EDIT_COLLECTION_CHAR_LIMIT ? (
                <></>
              ) : (
                <Box color="text-body-secondary">{epicDescrLimit}</Box>
              )
            }
            i18nStrings={{ errorIconAriaLabel: 'Error' }}
          >
            <Textarea
              value={collection?.description ?? ''}
              onChange={(event) => updateDescr(event.detail.value)}
              autoFocus
              ariaRequired
            />
          </FormField>
        ) : (
          <Box padding={{ top: 'm' }} fontSize="heading-m" fontWeight="light" variant="h5">
            {collection?.description ?? ''}
          </Box>
        )}
        {editingDescr ? (
          <Button
            variant="link"
            onClick={handleEditDescr}
            // @ts-expect-error TS18048 - strict migration
            disabled={collection?.description.length > EDIT_COLLECTION_CHAR_LIMIT}
          >
            {constants.DONE_EDIT_HEADER}
          </Button>
        ) : (
          <Button
            ariaLabel="Edit description"
            iconAlt="Edit description"
            iconName="edit"
            variant="inline-icon"
            onClick={handleEditDescr}
          />
        )}
      </div>
    );
  };

  return (
    <div className="edit-collection-header">
      {renderTitle()}
      {renderDescription()}
    </div>
  );
}

export default EditCollectionHeader;
